var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D5284",
    d: "M.133 1.733H11.96l3.2 5.334h16.707V27.2a3.067 3.067 0 0 1-2.95 3.064l-.117.003h-4.667v-.8H28.8a2.267 2.267 0 0 0 2.264-2.157l.003-.11V7.867h-16.36l-3.2-5.334H.933V27.2c0 1.215.956 2.207 2.157 2.264l.11.003h4.667v.8H3.2a3.067 3.067 0 0 1-3.064-2.95L.133 27.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D5E",
    d: "M21.733 22v8.267H10.267V22zm-.8.8h-9.866v6.667h9.866zM16 25.2a.933.933 0 1 1 0 1.867.933.933 0 0 1 0-1.867M16 14a3.6 3.6 0 0 1 3.598 3.474l.002.126v2.533h-.8V17.6a2.8 2.8 0 0 0-5.598-.115l-.002.115v2.533h-.8V17.6A3.6 3.6 0 0 1 16 14"
  })));
};
export default SvgSecurity;